import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Session token management — fetched from /api/config, rotated on every response.
let sessionToken = null;

// Create an axios instance that auto-attaches and rotates the session token.
const api = axios.create({ baseURL: API });

// Attach token to every outgoing request (except the initial /config fetch).
api.interceptors.request.use((config) => {
  if (sessionToken) {
    config.headers["X-Session-Token"] = sessionToken;
  }
  return config;
});

// Rotate: if the backend returns a new token in the response header, store it.
api.interceptors.response.use((response) => {
  const newToken = response.headers["x-session-token"];
  if (newToken) {
    sessionToken = newToken;
  }
  return response;
});

export const fetchConfig = async () => {
  const { data } = await api.get("/config");
  // The initial session token comes in the response body from /config.
  if (data.session_token) {
    sessionToken = data.session_token;
  }
  return data;
};

export const submitLead = async ({ email, name, source }) => {
  const { data } = await api.post("/leads", { email, name, source });
  return data;
};

// `items` is the catalog-driven line-item list: [{ id, quantity }].
export const createCheckoutSession = async ({ email, items, origin_url }) => {
  const { data } = await api.post("/checkout/session", { email, items, origin_url });
  return data;
};

export const getCheckoutStatus = async (sessionId, { paymentId } = {}) => {
  const params = {};
  if (paymentId) params.payment_id = paymentId;
  const { data } = await api.get(`/checkout/status/${sessionId}`, { params });
  return data;
};

// Magic-link download recovery
export const requestDownloadLink = async (email) => {
  const { data } = await api.post("/downloads/request", { email });
  return data;
};

export const getDownloadsByToken = async (token) => {
  const { data } = await api.get("/downloads/access", { params: { token } });
  return data;
};
